import { createSlice } from "@reduxjs/toolkit";
import {
  AddHobbyAction,
  DeleteHobbyAction,
  GetAllHobbyAction,
  UpdateHobbyAction,
} from "store/middlewares/dataManagement/hobby";

// isDeleteMeFulFilled
export const hobbySlice = createSlice({
  name: "hobby",
  initialState: {
    hobbyLoading: true,
    hobby: null,
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllHobbyAction.pending, (state) => {
        // state.hobbyLoading = true;
        // state.hobby = null;
        state.hobby = state.hobby?.data?.length > 0 ? state.hobby : null;
      })
      .addCase(GetAllHobbyAction.fulfilled, (state, action) => {
        state.hobbyLoading = false;
        state.hobby = action.payload.response;
      })
      .addCase(GetAllHobbyAction.rejected, (state) => {
        state.hobbyLoading = false;
        state.hobby = null;
      })
      // Delete
      .addCase(DeleteHobbyAction.fulfilled, (state, action) => {
        // state.hobbyLoading = false;
        // state.hobby = {
        //   ...state.hobby,
        //   total: Number(state.hobby.total) - 1,
        //   data: state.hobby?.data?.filter(
        //     (item) => item.id !== action.payload.id
        //   ),
        // };
        state.hobbyLoading = false;
        state.hobby = action.payload.response;
      })
      //Update
      .addCase(UpdateHobbyAction.fulfilled, (state, action) => {
        state.hobbyLoading = false;
        state.hobby = {
          ...state.hobby,
          data: state.hobby.data.map((item) =>
            item.id === action.payload.response.id
              ? action.payload.response
              : item
          ),
        };
      })

      //Add
      .addCase(AddHobbyAction.fulfilled, (state, action) => {
        // state.hobbyLoading = false;
        // state.hobby = {
        //   ...state.hobby,
        //   total: Number(state.hobby.total) + 1,
        //   data: [action.payload.response, ...state.hobby.data],
        // };
        state.hobbyLoading = false;
        state.hobby = action.payload.response;
      });
  },
});

export default hobbySlice.reducer;
